import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';


//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';
import { environment } from '../../../environments/environment';


declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-shop-products',
  templateUrl: './shop-products.component.html',
  styleUrls: ['./shop-products.component.css']
})
export class ShopProductsComponent implements OnInit {

  pageName = "Shop Products";
  modelName = "Product";
  products: any;
  p: number = 1;
  itemsPerPage = 20;
  displayedProducts = []
  loading = true
  maxPrice = 25000

  departments = []
  categories = []
  subcategories = []

  catalogueReady = false
  numberOfValidProducts = 0

  constructor(
    private router: Router,
    private _data: CommonDataService
  ) { 

    console.log(_data.queryParams);

    let queryData = new FormData();
    queryData.append('modelName', this.modelName);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelDataShopModels(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          this.products = data['covers'];
          
          if(data['covers'].length > 0) {
            this.displayedProducts = this.getValidProducts()

            this.numberOfValidProducts = this.displayedProducts.length
            
          }

          this.loading = false

        },
        error => {

          console.log(error);
          iziToast.success({
            title: 'Error!',
            position: 'topRight',
            icon: 'icon-circle-check',
            message: 'Failed to get products.'
        });

        $('#loader').hide();

        this.loading = false

        },

        () => {
            $('#loader').hide();
            this.loading = false
        }
      );


  }

  getDepartments() {

    $('#loader').show();

    let queryData = new FormData();
    queryData.append('modelName', "Departments");

    //lets get the model for this page
    this._data.getModelDataShopModels(queryData) 
    .pipe(first())
    .subscribe(
      data => {
        
        if(data['covers'].length > 0) {
          this.departments = data['covers'].filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['departmentDetails']['category_status'] === "active");
        }

      },
      error => {},
      () => {
          this.getCategories()
      }
    );
  }

  getCategories() {

    let queryData = new FormData();
    queryData.append('modelName', "ShopCategory");

    this._data.getModelDataShopModels(queryData) 
    .pipe(first())
    .subscribe(
      data => {
        
        if(data['covers'].length > 0) {
          this.categories = data['covers'].filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['category_status'] === "active");
        }

        this.loading = false

      },
      error => {
      },

      () => {
          this.getSubCategories()
      }
    );

  }
  
  getSubCategories() {

    let queryData = new FormData();
    queryData.append('modelName', "SubCategory");
    this._data.getModelDataShopModels(queryData) 
    .pipe(first())
    .subscribe(
      data => {
        
        if(data['covers'].length > 0) {
          this.subcategories = data['covers'].filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['category_status'] === "active");
        }

        this.catalogueReady = true
        console.log(this.subcategories)
        $('#initialise-page').trigger('click');
      },
      error => {

      },

      () => {
      }
    );

  }

  ngOnInit() {

    $('#initialise-page').trigger('click');
    
    
    this.getDepartments()
    // this.getCategories()
    // this.getSubCategories()
  }

  productSelected(details) {

  }

  sortProducts(sortKey) {

    this.displayedProducts = []
    let prods = []

    if(sortKey == 'choose-filter') {
      return true;
    }

    $('#loader').show();
    this.loading = true


    if(sortKey == 'name-acsending' || sortKey == 'name-desc') {
      if(sortKey == 'name-acsending') {
        prods = this.products.sort((a,b)=>a['cover']['model']['modelData']['formFieldsEntities']['productDetails']['name'] > b['cover']['model']['modelData']['formFieldsEntities']['productDetails']['name'] ? 1 : -1)
        // alert(sortKey)
        
      }

        else {
          prods = this.products.sort((a,b)=>a['cover']['model']['modelData']['formFieldsEntities']['productDetails']['name'] < b['cover']['model']['modelData']['formFieldsEntities']['productDetails']['name'] ? 1 : -1)
          console.log(prods)
        }
    }

    if(sortKey == 'price-acsending' || sortKey == 'price-desc') {
      if(sortKey == 'price-desc') {
        prods = this.products.sort((a,b)=>b['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price'] - a['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price'])
        console.log(prods)

      }

        else {

          prods = this.products.sort((a,b)=>a['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price'] - b['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price'])
          console.log(prods)
          
        }
    }

    //this.displayedProducts = prods//this.filterProducts(prods)
    let newDataOrder = this.filterProducts(prods)
    this.reloadData(newDataOrder)

    $('#loader').hide();
    this.loading = false

  }

  filterPriceProducts() {
    let minValue = parseFloat($( "#min-price-val" ).val())
    let maxValue = parseFloat($( "#max-price-val" ).val())

    let prods = this.products.filter(prod => parseFloat(prod['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price']) > minValue && parseFloat( prod['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price']) < maxValue);
    this.reloadData(prods)

  }

  filterByCategoryId() {
    
  }

  reloadData(prods) {
    this.displayedProducts = [...prods];
  }
  

  filterProducts(prods) {
    return prods.filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['ProductFlags']['published'] === false);
  }

  getValidProducts() {
    // this.products.sort((a,b)=>a['cover']['model']['modelData']['formFieldsEntities']['productDetails']['name'].localeCompare(b['cover']['model']['modelData']['formFieldsEntities']['productDetails']['name']))
    // return this.products.sort((a,b)=>b['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price'] - a['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price'])

    return this.products.filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['ProductFlags']['published'] === false);
  }

  getProductImageSrc(modelData){

      if( modelData['files'] && modelData['files']['uploads'] && Array.isArray(modelData['files']['uploads']) && modelData['files']['uploads'].length > 0) {
        let productImages = modelData['files']['uploads']

        for (let index = 0; index < productImages.length; index++) {
          let element = productImages[index];

          if(element['tmp_name'] && element['tmp_name'] != '') {
            let srcStrings = element['tmp_name'].split("public/");
            let src = environment.filesSrc+'/'+srcStrings[1]
            element['src'] = src
            return src
          }
          
        }

      }

      return ''
  }

  filterSubCategoris(parentCatId) {
    return this.subcategories.filter(cat => cat['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['store_department_category'] == parentCatId);
  }

}
